<template>
  <v-col cols="12" class="px-8" v-if="permisoVista('dashboard','r')">
    <v-row>
      <v-col cols="6" md="6" sm="6" class="align-self-end">
        <datePicker
          v-model="desde"
          format="YYYY-MM-DD"
          :maxDate="fin"
          label="Selecciona una Fecha (Obligatorio)"
          clearable
          maxToday
          @input="onFiltroChanged"
          :disabled="cargando"
        ></datePicker>
      </v-col>
      <!-- <v-col cols="3" md="3" sm="3" class="align-self-end">
        <datePicker
          v-model="hasta"
          :minDate="desde"
          format="YYYY-MM-DD"
          label="Hasta (Obligatorio)"
          clearable
          maxToday
          @input="onFiltroChanged"
          :disabled="cargando"
        ></datePicker>
      </v-col> -->
      <v-col cols="6" md="6" sm="6" class="align-self-end">
        <v-autocomplete
          v-model="idsMaquinasIns"
          label="Instancias de Máquinas (Obligatorio)"
          :items="maquinasIns"
          item-value="idMaquinaIns"
          :item-text="nombreMaquina"
          multiple
          clearable
          @change="onFiltroChanged"
          :disabled="cargando"
          dense
          hide-details
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row class="px-0 ma-0">
      <v-col cols="12" class="d-flex align-center justify-space-between py-0">
        <v-switch
          v-model="autoActualizar"
          label="Actualización automática"
          inset
          dense
          :disabled="cargando"
          class="ma-0"
          @change="onToggleAutoActualizar"
        />
        <v-btn
          color="primary"
          :disabled="!realizarPeticion || cargando"
          :loading="cargando"
          @click="consultar"
        >
          Consultar
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="realizarPeticion && autoActualizar" class="px-0 ma-0">
      <v-col cols="12" class="ma-0 text-right text-subtitle-2">
        Próxima Actualización en {{ tiempo }}
      </v-col>
    </v-row>
    <v-progress-linear
      v-if="cargando"
			color="primary"
			height="5"
			indeterminate
		></v-progress-linear>
    <br>
    <v-simple-table v-if="!cargando">
      <template v-slot:default>
        <thead>
          <!-- Header fila 1: Fechas agrupadas -->
          <tr>
            <th class="font-weight-bold text-center">No. de Parte</th>
            <th></th>

            <th
              v-for="(fecha,idx) in fechasPlain"
              :key="`fechaG-${idx}`"
              class="font-weight-bold text-center"
              :colspan="4"
            >
              {{ fechas[idx] }}
            </th>

            <th
              v-if="fechasPlain.length > 1"
              class="font-weight-bold text-center"
              :colspan="4"
            >
              Total Turnos
            </th>
          </tr>

          <!-- Header fila 2: Subcolumnas -->
          <tr>
            <th></th>
            <th></th>

            <template v-for="(fecha,idx) in fechasPlain">
              <th :key="`sub-${idx}-d`" class="text-center">Día</th>
              <th :key="`sub-${idx}-t1`" class="text-center">T1</th>
              <th :key="`sub-${idx}-t2`" class="text-center">T2</th>
              <th class="text-center">
                <span
                  title="Turno 3 cruza medianoche. Abajo se muestra: hoy + (parte del día siguiente)"
                >
                  {{ fechasPlain.length > 2 ? 'T3' : 'T3 (→ día sig.)' }}
                </span>
              </th>
            </template>

            <template v-if="fechasPlain.length > 1">
              <th class="text-center">Resumen Dias</th>
              <th class="text-center">T1</th>
              <th class="text-center">T2</th>
              <th class="text-center">T3</th>
            </template>
          </tr>
        </thead>

        <tbody>
          <template v-for="(dato,idx) in datos">
            <!-- ====== HORAS ====== -->
            <tr :key="`r-h-${idx}`">
              <td rowspan="5">{{ dato.maquinaInsNombre }}</td>
              <td>Horas Laboradas</td>

              <template v-for="(fecha, j) in fechasPlain">
                <td :key="`h-${idx}-${j}-d`">{{ fmtH(sumByDay(dato, fecha, 'horas')) }}</td>
                <td :key="`h-${idx}-${j}-1`" :class="cellClassTurno(dato, fecha, 1)">
                  <div v-if="tieneActividadTurno(dato, fecha, 1)">{{ fmtH(getByTurno(dato, fecha, 1, 'horas')) }}</div>
                  <div v-else class="text-center grey--text text--lighten-1">—</div>
                </td>

                <td :key="`h-${idx}-${j}-2`" :class="cellClassTurno(dato, fecha, 2)">
                  <div v-if="tieneActividadTurno(dato, fecha, 2)">{{ fmtH(getByTurno(dato, fecha, 2, 'horas')) }}</div>
                  <div v-else class="text-center grey--text text--lighten-1">—</div>
                </td>
                <td :key="`h-${idx}-${j}-3`" :class="cellClassTurno(dato, fecha, 3)">
                  <div v-if="tieneActividadTurno(dato, fecha, 3)">
                    <div>{{ fmtH(t3Split(dato, fecha, 'horas').base) }}</div>

                    <div class="caption grey--text text--lighten-1" style="line-height:1.2;">
                      <span v-if="!sinProduccionNextTurno(dato, fecha, 3)">
                        +{{ fmtH(t3Split(dato, fecha, 'horas').next) }}
                      </span>
                      <span v-else>
                        +{{ fmtH(t3Split(dato, fecha, 'horas').next) }} (no cuenta)
                      </span>
                    </div>
                  </div>
                  <div v-else class="text-center grey--text text--lighten-1">—</div>
                </td>
              </template>
              <template v-if="fechasPlain.length > 1">
                <td>{{ fmtH(sumPeriod(dato, 'horas')) }}</td>
                <td>{{ fmtH(sumPeriodTurno(dato, 1, 'horas')) }}</td>
                <td>{{ fmtH(sumPeriodTurno(dato, 2, 'horas')) }}</td>
                <td>{{ fmtH(sumPeriodTurno(dato, 3, 'horas')) }}</td>
              </template>
            </tr>

            <!-- ====== PLANEADAS ====== -->
            <tr :key="`r-p-${idx}`">
              <td>Pza Planeadas</td>

              <template v-for="(fecha, j) in fechasPlain">
                <td :key="`p-${idx}-${j}-d`">{{ fmtP(sumByDay(dato, fecha, 'planeacion')) }}</td>
                <td :key="`p-${idx}-${j}-1`" :class="cellClassTurno(dato, fecha, 1)">{{ fmtP(getByTurno(dato, fecha, 1, 'planeacion')) }}</td>
                <td :key="`p-${idx}-${j}-2`" :class="cellClassTurno(dato, fecha, 2)">{{ fmtP(getByTurno(dato, fecha, 2, 'planeacion')) }}</td>
                <td :key="`p-${idx}-${j}-3`" :class="cellClassTurno(dato, fecha, 3)">
                  <div>
                    <div>{{ fmtP(t3SplitPlaneacion(dato, fecha).base) }}</div>
                    <div class="caption grey--text text--lighten-1" style="line-height:1.2;">
                      +{{ fmtP(t3SplitPlaneacion(dato, fecha).next) }}
                    </div>
                  </div>
                </td>
              </template>
              <template v-if="fechasPlain.length > 1">
                <td>{{ fmtP(sumPeriod(dato, 'planeacion')) }}</td>
                <td>{{ fmtP(sumPeriodTurno(dato, 1, 'planeacion')) }}</td>
                <td>{{ fmtP(sumPeriodTurno(dato, 2, 'planeacion')) }}</td>
                <td>{{ fmtP(sumPeriodTurno(dato, 3, 'planeacion')) }}</td>
              </template>
            </tr>

            <!-- ====== REALIZADAS (con OK/NoOK) ====== -->
            <tr :key="`r-r-${idx}`">
              <td>Pza Realizadas</td>

              <template v-for="(fecha, j) in fechasPlain">
                <!-- Día -->
                <td :key="`r-${idx}-${j}-d`">
                  <div>
                    <div style="font-size:14px;">{{ fmtP(sumByDay(dato, fecha, 'realizado')) }}</div>
                    <div style="font-size:12px;color:#9e9e9e;line-height:2.0;">
                      OK: {{ fmtP(sumByDay(dato, fecha, 'realizadoOk')) }} · NoOK: {{ fmtP(sumByDay(dato, fecha, 'realizadoNoOk')) }}
                    </div>
                  </div>
                </td>

                <!-- Turnos -->
                <td :key="`r-${idx}-${j}-1`" :class="cellClassTurno(dato, fecha, 1)">
                  <div>
                    <div style="font-size:14px;">{{ fmtP(getByTurno(dato, fecha, 1, 'realizado')) }}</div>

                    <div v-if="sinProduccionTurno(dato, fecha, 1)"
                        style="font-size:12px;color:#9e9e9e;line-height:1.6;">
                      Sin producción
                    </div>

                    <div style="font-size:12px;color:#9e9e9e;line-height:2.0;">
                      OK: {{ fmtP(getByTurno(dato, fecha, 1, 'realizadoOk')) }} · NoOK: {{ fmtP(getByTurno(dato, fecha, 1, 'realizadoNoOk')) }}
                    </div>
                  </div>
                </td>

                <td :key="`r-${idx}-${j}-2`" :class="cellClassTurno(dato, fecha, 2)">
                  <div>
                    <div style="font-size:14px;">{{ fmtP(getByTurno(dato, fecha, 2, 'realizado')) }}</div>

                    <div v-if="sinProduccionTurno(dato, fecha, 2)"
                        style="font-size:12px;color:#9e9e9e;line-height:1.6;">
                      Sin producción
                    </div>

                    <div style="font-size:12px;color:#9e9e9e;line-height:2.0;">
                      OK: {{ fmtP(getByTurno(dato, fecha, 2, 'realizadoOk')) }} · NoOK: {{ fmtP(getByTurno(dato, fecha, 2, 'realizadoNoOk')) }}
                    </div>
                  </div>
                </td>

                <td :key="`r-${idx}-${j}-3`" :class="cellClassTurno(dato, fecha, 3)">
                  <div v-if="tieneActividadTurno(dato, fecha, 3)">
                    <div style="font-size:14px;">
                      {{ fmtP(t3SplitPiezas(dato, fecha).realizado.base) }}
                    </div>

                    <div class="caption grey--text text--lighten-1" style="line-height:1.2;"
                        v-if="t3SplitPiezas(dato, fecha).realizado.next > 0">
                      +{{ fmtP(t3SplitPiezas(dato, fecha).realizado.next) }}
                    </div>

                    <div v-if="sinProduccionTurno(dato, fecha, 3)"
                        style="font-size:12px;color:#9e9e9e;line-height:1.6;">
                      Sin producción
                    </div>

                    <div style="font-size:12px;color:#9e9e9e;line-height:2.0;">
                      OK: {{ fmtP(t3SplitPiezas(dato, fecha).ok.base) }}
                      <span v-if="t3SplitPiezas(dato, fecha).ok.next > 0">
                        (+{{ fmtP(t3SplitPiezas(dato, fecha).ok.next) }})
                      </span>
                      ·
                      NoOK: {{ fmtP(t3SplitPiezas(dato, fecha).noOk.base) }}
                      <span v-if="t3SplitPiezas(dato, fecha).noOk.next > 0">
                        (+{{ fmtP(t3SplitPiezas(dato, fecha).noOk.next) }})
                      </span>
                    </div>
                  </div>

                  <div v-else class="text-center grey--text text--lighten-1">—</div>
                </td>
              </template>

              <!-- Totales periodo -->
              <template v-if="fechasPlain.length > 1">
                <td>
                  <div>
                    <div style="font-size:14px;">{{ fmtP(sumPeriod(dato, 'realizado')) }}</div>
                    <div style="font-size:12px;color:#9e9e9e;line-height:2.0;">
                      OK: {{ fmtP(sumPeriod(dato, 'realizadoOk')) }} · NoOK: {{ fmtP(sumPeriod(dato, 'realizadoNoOk')) }}
                    </div>
                  </div>
                </td>
                <td>{{ fmtP(sumPeriodTurno(dato, 1, 'realizado')) }}</td>
                <td>{{ fmtP(sumPeriodTurno(dato, 2, 'realizado')) }}</td>
                <td>{{ fmtP(sumPeriodTurno(dato, 3, 'realizado')) }}</td>
              </template>
            </tr>

            <!-- ====== % cumplimiento ====== -->
            <tr :key="`r-e-${idx}`">
              <td>% Cumplimiento Plan</td>

              <template v-for="(fecha, j) in fechasPlain">
                <td :key="`e-${idx}-${j}-d`">
                  {{ fmtPct(pct(sumByDay(dato, fecha, 'realizado'), sumByDay(dato, fecha, 'planeacion'))) }} %
                </td>
                <td :key="`e-${idx}-${j}-1`" :class="cellClassTurno(dato, fecha, 1)">
                  {{ fmtPct(pct(
                    turnoValorBase(dato, fecha, 1, 'realizado'),
                    turnoValorBase(dato, fecha, 1, 'planeacion')
                  )) }} %
                </td>
                <td :key="`e-${idx}-${j}-2`" :class="cellClassTurno(dato, fecha, 2)">
                  {{ fmtPct(pct(
                    turnoValorBase(dato, fecha, 2, 'realizado'),
                    turnoValorBase(dato, fecha, 2, 'planeacion')
                  )) }} %
                </td>
                <td :key="`e-${idx}-${j}-3`" :class="cellClassTurno(dato, fecha, 3)">
                  {{ fmtPct(pct(
                    turnoValorBase(dato, fecha, 3, 'realizado'),
                    turnoValorBase(dato, fecha, 3, 'planeacion')
                  )) }} %
                </td>
              </template>

              <template v-if="fechasPlain.length > 1">
                <td>{{ pct(sumPeriod(dato,'realizado'), sumPeriod(dato,'planeacion')) }} %</td>
                <td>{{ pct(sumPeriodTurno(dato,1,'realizado'), sumPeriodTurno(dato,1,'planeacion')) }} %</td>
                <td>{{ pct(sumPeriodTurno(dato,2,'realizado'), sumPeriodTurno(dato,2,'planeacion')) }} %</td>
                <td>{{ pct(sumPeriodTurno(dato,3,'realizado'), sumPeriodTurno(dato,3,'planeacion')) }} %</td>
              </template>
            </tr>

            <!-- ====== Cumplimiento acumulado (solo Día) ====== -->
            <tr :key="`r-a-${idx}`">
              <td>Cumpl. Día Plan</td>

              <template v-for="(fecha, j) in fechasPlain">
                <td :key="`a-${idx}-${j}-d`">{{ acumPct(dato, fecha) }} %</td>
                <td :key="`a-${idx}-${j}-1`" :class="cellClassTurno(dato, fecha, 1)" class="text-center grey--text text--lighten-1">—</td>
                <td :key="`a-${idx}-${j}-2`" :class="cellClassTurno(dato, fecha, 2)" class="text-center grey--text text--lighten-1">—</td>
                <td :key="`a-${idx}-${j}-3`" :class="cellClassTurno(dato, fecha, 3)" class="text-center grey--text text--lighten-1">—</td>
              </template>
              <template v-if="fechasPlain.length > 1">
              <td></td><td></td><td></td><td></td>
              </template>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
    <br>
    <br>
    <v-expansion-panels multiple>
      <v-expansion-panel>
        <v-expansion-panel-header>Producción Objetivo por Día</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Fecha / Máquina</th>
                  <th class="text-center" v-for="maquinaIns in categorias" :key="`maqIns-${maquinaIns.idMaquinaIns}`">{{maquinaIns.nombre}}</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(fecha,idx) in fechas">
                  <tr :key="`fecha-${idx}`">
                    <td>
                      {{fecha}}
                    </td>
                    <td class="text-center" v-for="(maquinaIns,idy) in categorias" :key="`dato-${idx}-${idy}`">
                      <number-input
                      :value="obtenerValor(idx,idy)"
                      controls
                      inline
                      size="small"
                      min="0"
                      center
                      @change="cambioValor($event,idx,idy)"
                    ></number-input>
                    </td>
                  </tr>
                </template>
              </tbody>
          </template>
          </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>Producción Objetivo Intervalo</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Fecha / Máquina</th>
                  <th class="text-center" v-for="maquinaIns in categorias" :key="`maqIns-${maquinaIns.idMaquinaIns}`">{{maquinaIns.nombre}}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{desde}} <-> {{hasta}}
                  </td>
                  <td class="text-center" v-for="(maquinaIns,idy) in categorias" :key="`dato-${idy}`">
                    <number-input
                    controls
                    inline
                    size="small"
                    min="0"
                    center
                    @change="cambioValorRango($event,maquinaIns)"
                  ></number-input>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-col>
</template>

<script>
import axios from "axios"

export default {
  props:{
    active:{
      type: Boolean,
      default: false,
    }
  },
  computed:{
    realizarPeticion(){
      if(this.desde != null /* && this.hasta != null */ && this.$utils.isValid(this.idsMaquinasIns) && this.idsMaquinasIns.length > 0) return true;
      else return false;
      
    },
    url(){
      var url = `/Dashboard/Tabla1?Desde=${this.desde}&Hasta=${this.desde}`;
      if(this.idsMaquinasIns.length > 0){
        this.idsMaquinasIns.forEach(idMaquinaIns => {
          url += `&IdsMaquinasIns=${idMaquinaIns}`;
        })
      }
      return url;
    },
    tiempo(){
      return this.$utils.strings.toTime(this.segundos);
    },
    fechasPlain(){
      // "[miércoles] 2025-12-10" -> "2025-12-10"
      return (this.fechas || []).map(x => {
        const i = x.indexOf("] ");
        return i >= 0 ? x.substr(i+2).trim() : x;
      });
    }
  },
  data: () => ({
    interval: null,
    segundos: 60,
    cargando: false,
    autoActualizar: true,
    desde: null,
    hasta:null,
    fechas: [],
    datos: [],
    categorias:[],
    maquinasIns:[],
    idsMaquinasIns: [],
    objetivos: [],
  }),
  methods:{
    consultar(){
      this.obtenerDatos();
    },
    onToggleAutoActualizar(val){
      // si apaga, congela el contador en 60 (o lo dejas como está)
      if(!val){
        this.segundos = 60;
      }
    },
    onFiltroChanged(){
      // Ya no consultamos aquí.
      // Solo refrescamos catálogo de máquinas cuando cambian fechas
      this.getMaquinaIns();

      // si quieres limpiar datos al cambiar filtros (opcional):
      // this.datos = [];
      // this.fechas = [];
      // this.categorias = [];
      // this.objetivos = [];

      // reset del contador
      this.segundos = 60;
    },
    cellClassTurno(dato, fechaISO, idTurno){
      // si el turno es sin producción -> rojo
      if(this.sinProduccionTurno(dato, fechaISO, idTurno)) return 'bg-sinprod';

      // regla extra: para T3, si el NEXT fue sin producción, también lo pintas
      if(Number(idTurno) === 3 && this.sinProduccionNextTurno(dato, fechaISO, 3)) return 'bg-sinprod';

      return '';
    },
    turnoValorBase(dato, fechaISO, idTurno, campo){
      const r = this.findTurno(dato, fechaISO, idTurno);
      if(!r) return 0;

      // si el turno es "Sin producción", no cuenta nada (horas, planeación, realizado, etc.)
      if (r.sinProduccion ?? r.SinProduccion) {
        if (['horas','planeacion','realizado','realizadoOk','realizadoNoOk'].includes(campo)) return 0;
      }

      const v     = Number(r[campo] ?? r[campo.charAt(0).toUpperCase()+campo.slice(1)] ?? 0) || 0;
      const vNext = Number(r[`${campo}Next`] ?? r[`${campo.charAt(0).toUpperCase()+campo.slice(1)}Next`] ?? 0) || 0;

      // T3: el "Día" solo cuenta BASE (hoy). El next (día sig) NO entra al total del día
      if (Number(idTurno) === 3 && campo === 'planeacion') {
        const total = Number(r.planeacion ?? r.Planeacion ?? 0) || 0;
        const next  = Number(r.planeacionNext ?? r.PlaneacionNext ?? 0) || 0;

        const hTotal = Number(r.horas ?? r.Horas ?? 0) || 0;
        const hNext  = Number(r.horasNext ?? r.HorasNext ?? 0) || 0;

        const realBase = Number(r.realizado ?? r.Realizado ?? 0) || 0;
        const realNext = Number(r.realizadoNext ?? r.RealizadoNext ?? 0) || 0;

        const eps = 0.0001;
        const todoEsNextPorHoras = (hNext > eps) && (Math.max(0, hTotal - hNext) <= eps);
        const todoEsNextPorRealizado = (realNext > 0) && (realBase <= eps);

        if(next <= 0 && total > 0 && (todoEsNextPorHoras || todoEsNextPorRealizado)){
          return 0; // todo era del día siguiente, entonces "hoy" no tiene plan
        }

        return Math.max(0, total - next);
      }

      return v;
    },
    t3SplitPlaneacion(dato, fechaISO){
      const r = this.findTurno(dato, fechaISO, 3);
      if(!r) return { base: 0, next: 0 };

      const total = Number(r.planeacion ?? r.Planeacion ?? 0) || 0;
      let next    = Number(r.planeacionNext ?? r.PlaneacionNext ?? 0) || 0;

      const hTotal = Number(r.horas ?? r.Horas ?? 0) || 0;
      const hNext  = Number(r.horasNext ?? r.HorasNext ?? 0) || 0;

      const realBase = Number(r.realizado ?? r.Realizado ?? 0) || 0;      // base (hoy)
      const realNext = Number(r.realizadoNext ?? r.RealizadoNext ?? 0) || 0; // next (día sig)

      const eps = 0.0001;

      // Caso típico de tus capturas:
      // - hay horasNext, y horas "base" es ~0 (o sea, todo fue después de medianoche)
      const todoEsNextPorHoras = (hNext > eps) && (Math.max(0, hTotal - hNext) <= eps);

      // Alternativa: el backend ya separó realizado (base=0 y next>0)
      const todoEsNextPorRealizado = (realNext > 0) && (realBase <= eps);

      // Si el backend no manda planeacionNext, pero el turno fue 100% del día sig,
      // entonces mueve TODO el plan a next.
      if(next <= 0 && total > 0 && (todoEsNextPorHoras || todoEsNextPorRealizado)){
        return { base: 0, next: total };
      }

      // Normal: base = total - next
      const base = Math.max(0, total - next);
      return { base, next };
    },
    sinProduccionNextTurno(dato, fechaISO, idTurno){
      const r = this.findTurno(dato, fechaISO, idTurno);
      if(!r) return false;

      const hNext    = Number(r.horasNext ?? r.HorasNext ?? 0) || 0;
      const realNext = Number(r.realizadoNext ?? r.RealizadoNext ?? 0) || 0;

      // Si hay horasNext pero no hay piezas reales en next -> es inflado/teórico -> no cuenta
      return (hNext > 0.0001) && (realNext <= 0.0001);
    },

    horasEfectivasTurno(dato, fechaISO, idTurno){
      const r = this.findTurno(dato, fechaISO, idTurno);
      if(!r) return 0;

      const h = Number(r.horas ?? r.Horas ?? 0) || 0;

      // solo aplica a T3 (porque es el que trae next)
      if(Number(idTurno) !== 3) return h;

      const hNext = Number(r.horasNext ?? r.HorasNext ?? 0) || 0;

      // si el NEXT fue sin producción, no lo sumes
      if(this.sinProduccionNextTurno(dato, fechaISO, 3)) {
        return Math.max(0, h - hNext);
      }

      return h;
    },
    t3SplitPiezas(dato, fechaISO){
      const r = this.findTurno(dato, fechaISO, 3);
      if(!r) return {
        realizado: { base:0, next:0 },
        ok:       { base:0, next:0 },
        noOk:     { base:0, next:0 },
      };

      const realBase = Number(r.realizado ?? r.Realizado ?? 0) || 0;
      const realNext = Number(r.realizadoNext ?? r.RealizadoNext ?? 0) || 0;

      const okBase   = Number(r.realizadoOk ?? r.RealizadoOk ?? 0) || 0;
      const okNext   = Number(r.realizadoOkNext ?? r.RealizadoOkNext ?? 0) || 0;

      const noBase   = Number(r.realizadoNoOk ?? r.RealizadoNoOk ?? 0) || 0;
      const noNext   = Number(r.realizadoNoOkNext ?? r.RealizadoNoOkNext ?? 0) || 0;

      // lo “del día” es total - next (como pediste)
      return {
        realizado: { base: Math.max(0, realBase - realNext), next: realNext },
        ok:       { base: Math.max(0, okBase   - okNext),   next: okNext   },
        noOk:     { base: Math.max(0, noBase   - noNext),   next: noNext   },
      };
    },
    hasTurno(dato, fechaISO, idTurno){
      const r = this.findTurno(dato, fechaISO, idTurno);
      return !!r;
    },
    tieneActividadTurno(dato, fechaISO, idTurno){
      const r = this.findTurno(dato, fechaISO, idTurno);
      return !!(r && (r.tieneActividad ?? r.TieneActividad));
    },
    sinProduccionTurno(dato, fechaISO, idTurno){
      const r = this.findTurno(dato, fechaISO, idTurno);
      return !!(r && (r.sinProduccion ?? r.SinProduccion));
    },
    t3Split(dato, fechaISO, campo){
      const r = this.findTurno(dato, fechaISO, 3);
      if(!r) return { base: 0, next: 0 };

      const total = Number(r[campo] ?? r[campo.charAt(0).toUpperCase()+campo.slice(1)] ?? 0) || 0;
      const next  = Number(r[`${campo}Next`] ?? r[`${campo.charAt(0).toUpperCase()+campo.slice(1)}Next`] ?? 0) || 0;

      const dia = Math.max(0, total - next);

      // Si el next es “fantasma”, no lo muestres
      const nextCuenta = !this.sinProduccionNextTurno(dato, fechaISO, 3);
      return { base: dia, next: nextCuenta ? next : 0 };
    },
    fmtN(v, dec = 0){
      const n = Number(v) || 0;
      return n.toLocaleString('en-US', {
        minimumFractionDigits: dec,
        maximumFractionDigits: dec
      });
    },
    fmtH(v){ // horas
      return this.fmtN(v, 2);
    },
    fmtP(v){ // piezas
      return this.fmtN(v, 0);
    },
    fmtPct(v){ // porcentaje
      return this.fmtN(v, 2);
    },
    totalOk(dato){
      if(!dato || !dato.datos) return 0;
      return dato.datos.reduce((acc, x) => acc + (Number(x.realizadoOk) || 0), 0);
    },
    totalNoOk(dato){
      if(!dato || !dato.datos) return 0;
      return dato.datos.reduce((acc, x) => acc + (Number(x.realizadoNoOk) || 0), 0);
    },
    nombreMaquina: maquina => ` [${maquina.nombre}] - ${maquina.marca} ${maquina.modelo}`,
    obtenerValor(x,y){
      if(this.$utils.isValid(this.objetivos[x])){
        if(this.$utils.isValid(this.objetivos[x][y])){
          return this.$utils.isValid(this.objetivos[x][y]) ? this.objetivos[x][y] : 0;
        }
        else return 0;
      }
      else return 0;
    },
    // busca un registro por fecha+turno
    findTurno(dato, fechaISO, idTurno){
      const arr = dato && (dato.datosTurnos || dato.datosTurno || []);
      const fechaKey = (fechaISO || "").substr(0, 10); // "2025-12-10"

      return arr.find(x => {
        const fx = (x.fecha || x.Fecha || "").toString().substr(0, 10); // "2025-12-10"
        const tx = Number(x.idTurno ?? x.IdTurno);
        return fx === fechaKey && tx === Number(idTurno);
      });
    },

    // obtiene un campo, si no existe -> 0
    getByTurno(dato, fechaISO, idTurno, campo){
      const r = this.findTurno(dato, fechaISO, idTurno);
      if(!r) return 0;
      const v = r[campo] ?? r[campo.charAt(0).toUpperCase()+campo.slice(1)];
      return Number(v) || 0;
    },

    // suma del día (Σ turnos)
    sumByDay(dato, fechaISO, campo){
      if(campo === 'horas'){
        return [1,2,3].reduce((acc,t)=> acc + this.horasEfectivasTurno(dato, fechaISO, t), 0);
      }

      // ✅ PLANEACION del día: incluye el next en T3 (porque así estás mostrando el Día en la UI)
      if(campo === 'planeacion'){
        const t1 = this.turnoValorBase(dato, fechaISO, 1, 'planeacion');
        const t2 = this.turnoValorBase(dato, fechaISO, 2, 'planeacion');

        // T3: usa TOTAL (base + next) siempre
        const r3 = this.findTurno(dato, fechaISO, 3);
        const total3 = r3 ? (Number(r3.planeacion ?? r3.Planeacion ?? 0) || 0) : 0;

        // si quieres que el next "no cuente" cuando fue sin producción next:
        // const nextCuenta = !this.sinProduccionNextTurno(dato, fechaISO, 3);
        // const base3 = this.t3SplitPlaneacion(dato, fechaISO).base;
        // const next3 = nextCuenta ? this.t3SplitPlaneacion(dato, fechaISO).next : 0;
        // const total3 = base3 + next3;

        return t1 + t2 + total3;
      }

      return [1,2,3].reduce((acc,t)=> acc + this.turnoValorBase(dato, fechaISO, t, campo), 0);
    },

    sumPeriod(dato, campo){
      return (this.fechasPlain || []).reduce((acc, f)=> acc + this.sumByDay(dato, f, campo), 0);
    },

    // suma periodo por turno
    sumPeriodTurno(dato, idTurno, campo){
      return (this.fechasPlain || []).reduce((acc, f)=> acc + this.turnoValorBase(dato, f, idTurno, campo), 0);
    },

    // porcentaje (2 dec)
    pct(real, plan){
      real = Number(real)||0; plan = Number(plan)||0;
      if(plan <= 0) return 0;
      return Math.round((real/plan)*10000)/100;
    },

    // cumplimiento acumulado por día (solo Día Σ turnos)
    acumPct(dato, fechaISO){
      let real = 0, plan = 0;
      for(const f of (this.fechasPlain || [])){
        plan += this.sumByDay(dato, f, 'planeacion');
        real += this.sumByDay(dato, f, 'realizado');
        if(f === fechaISO) break;
      }
      return this.pct(real, plan);
    },
    obtenerDatos(){
      if(!this.realizarPeticion || this.cargando) return;

      this.cargando = true;
      this.segundos = 60;

      axios
      .get(this.url)
      .then(response => {
        this.categorias = response.data.maquinaInstancias;
        this.objetivos = response.data.objetivos;
        this.fechas = response.data.fechas;
        this.datos = response.data.datos;
        this.cargando = false;

        if(this.autoActualizar) this.segundos = 60;
      })
      .catch(error => {
        this.cargando = false;
        console.log(error);
      })
    },
    getMaquinaIns(){
      if(this.desde==null){
        this.maquinasIns = [];
        return;
      }
      axios
      .get("/MaquinaInstancias/MaquinasConOperaciones",{
        params:{
          fechaInicio: this.desde,
          fechaFin: this.desde
          /* fechaFin: this.hasta */
        }
      })
      .then(response => {
        this.maquinasIns = response.data;
      })
      .catch(error => {
        console.log(error);
      })
    },
    cambioValor(event,idxFechas,idxMaquinaIns){
      if(event <= 0 || this.obtenerValor(idxFechas,idxMaquinaIns) == event) return;
      
      axios
      .post("/MaquinaInstanciaObjetivos/CrearActualizar",{
        idMaquinaIns: this.categorias[idxMaquinaIns].idMaquinaIns,
        cantidadObjetivo: event, 
        fecha: this.fechas[idxFechas].substr(this.fechas[idxFechas].indexOf("] ")+2)
      })
      .then(() => {
        this.obtenerDatos();
      })
      .catch(error => {
        console.log(error);
      })
    },
    cambioValorRango(event,maquinaIns){
      if(event <= 0) return;

      axios
      .put("/MaquinaInstanciaObjetivos/CrearActualizarRangoFechasObjetivo",{
        idMaquinaIns: maquinaIns.idMaquinaIns,
        cantidad: event, 
        rangoInicio: this.desde,
        rangoFin: this.hasta,
      })
      .then(() => {
        this.obtenerDatos();
      })
      .catch(error => {
        console.log(error);
      })
    }
  },
  mounted(){
    this.interval = setInterval(() => {
      if(!this.active) return;
      if(!this.autoActualizar) return;
      if(!this.realizarPeticion) return;
      if(this.cargando) return;

      if(this.segundos === 0) {
        this.obtenerDatos();
      } else {
        this.segundos -= 1;
      }
    }, 1000);
  },
  destroyed(){
    clearInterval(this.interval);
  }
}
</script>
<style scoped>
.bg-sinprod {
  background: #ffebee;          /* rojo clarito (Material Red 50) */
}
.bg-sinprod-soft {
  background: #fff5f5;          /* aún más leve */
}
</style>